import { all } from "redux-saga/effects";
import { appSaga } from "./app.saga";
import { authSaga } from "./auth/auth.saga";
import { permissionSaga } from "./auth/permission.saga";
import { roleSaga } from "./auth/role.saga";
import { clientSaga } from "./client.saga";
import { faqSaga } from "./faq.saga";
import { chatHistorySaga } from "./chatHistory.saga";
import { googleAdsSaga } from "./googleAds.saga";

function* rootSaga() {
  yield all([
    appSaga(),
    authSaga(),
    roleSaga(),
    permissionSaga(),
    clientSaga(),
    faqSaga(),
    chatHistorySaga(),
    googleAdsSaga(),
  ]);
}

export default rootSaga;
